const RPCUrls = {
  ethSepolia:
    'https://eth-sepolia.g.alchemy.com/v2/A9jG3FLFlgzwwhpuv0CmBxBAKhj9Gk1B',
  ethMainNet:
    'https://eth-mainnet.g.alchemy.com/v2/A9jG3FLFlgzwwhpuv0CmBxBAKhj9Gk1B',
  bnbTestNet:
    'https://bnb-testnet.g.alchemy.com/v2/A9jG3FLFlgzwwhpuv0CmBxBAKhj9Gk1B',
  bnbMainNet:
    'https://bnb-mainnet.g.alchemy.com/v2/A9jG3FLFlgzwwhpuv0CmBxBAKhj9Gk1B',
};

export default RPCUrls;
